import React, { useState } from 'react';

import { Grid, Typography, TextField, List, ListItem } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const ICLRunningWarmWithCode = (props) => {
  const handleChange = props.handleChange;

  const [incommingPower, set_incommingPower] = useState(
    props.data.incommingPower
  );
  const [E20lidsOpen, set_E20lidsOpen] = useState(props.data.E20lidsOpen);
  const [E20condensorBlocked, set_E20condensorBlocked] = useState(
    props.data.E20condensorBlocked
  );
  const [E20gasLeak, set_E20gasLeak] = useState(props.data.E20gasLeak);

  const [E75fanRunning, set_E75fanRunning] = useState(props.data.E75fanRunning);
  const [E80checkMotherboard, set_E80checkMotherboard] = useState(
    props.data.E80checkMotherboard
  );
  const [E80checkCompressor, set_E80checkCompressor] = useState(
    props.data.E80checkCompressor
  );

  const handleElementChange = (val, item) => {
    switch (item) {
      case 'incommingPower':
        set_incommingPower(val);
        break;
      case 'E20lidsOpen':
        set_E20lidsOpen(val);
        break;
      case 'E20condensorBlocked':
        set_E20condensorBlocked(val);
        break;
      case 'E20gasLeak':
        set_E20gasLeak(val);
        break;
      case 'E75fanRunning':
        set_E75fanRunning(val);
        break;
      case 'E80checkMotherboard':
        set_E80checkMotherboard(val);
        break;
      case 'E80checkCompressor':
        set_E80checkCompressor(val);
        break;

      default:
        break;
    }
    handleChange(val, item);
  };

  return (
    <Grid
      container
      rowSpacing={0}
      margin={0}
      columnSpacing={{ xs: 0 }}
      rowGap={0}
      style={{ marginLeft: 0, marginRight: 0 }}
    >
      <Grid sx={{ border: 'none', textAlign: 'left' }} item xs={12} md={12}>
        <Typography variant='h6' fontWeight='700' fontSize={18}>
          Running Warm
        </Typography>
        <Typography variant='h6' fontWeight='700' fontSize={18}>
          Which Code?
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          If tripping check incoming power
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(incommingPower)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='incommingPower'
          value={incommingPower}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={12}
        md={12}
      >
        <Typography
          variant='h6'
          fontWeight='700'
          fontSize={16}
          paddingLeft={1}
          height='40px'
        >
          If E20 Checks:
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Lids open for extended period</Typography>
      </Grid>

      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(E20lidsOpen)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='E20lidsOpen'
          value={E20lidsOpen}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>

      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Condenser blocked</Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(E20condensorBlocked)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='E20condensorBlocked'
          value={E20condensorBlocked}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>

      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Gas Leak</Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(E20gasLeak)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='E20gasLeak'
          value={E20gasLeak}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>

      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={12}
        md={12}
      >
        <Typography
          variant='h6'
          fontWeight='700'
          fontSize={16}
          paddingLeft={1}
          height='40px'
        >
          If E75 checks:
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Fan not running</Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(E75fanRunning)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='E75fanRunning'
          value={E75fanRunning}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={12}
        md={12}
      >
        <Typography
          variant='h6'
          fontWeight='700'
          fontSize={16}
          paddingLeft={1}
          height='40px'
        >
          If E80 Checks:
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          textAlign: 'left',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Check Compressor</Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(E80checkCompressor)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='E80checkCompressor'
          value={E80checkCompressor}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',

          textAlign: 'left',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Check motherboard</Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderLeft: 'none',
          background: greyOutEmptyTextField(E80checkMotherboard)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='E80checkMotherboard'
          value={E80checkMotherboard}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
        ></TextField>
      </Grid>
    </Grid>
  );
};

export default ICLRunningWarmWithCode;
